import React, { useState, useEffect } from "react";
import Typography from "@mui/material/Typography";

import { useAppContext } from '../../../AppContext';
import { useTheme } from '@mui/material/styles';

function Info() {   
    
    const theme = useTheme();
  const { url, themeData, siteData,  themeLoading, siteLoading, themeError, siteError, changeUrl, updateThemeData, updateSiteData } = useAppContext();
    const [themeCss, setThemeCss] = useState(null);
    const [loading, setLoading] = useState(true);
  
    useEffect(()=>{
      let custom_css = themeData && themeData ? JSON.parse(themeData && themeData.custom_css): null;
      setThemeCss(custom_css)
      setLoading(false)
    }, [themeData]);
    
    const infoContainer = {                            
        paddingLeft: theme.spacing(2),
        paddinRight: theme.spacing(2),
        bottom: theme.spacing(17),     
        '& h5': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 14,
            color: theme.palette.primary.location,        
            fontWeight: 100,
        },
        '& h6': {
            fontFamily: themeCss && themeCss.theme_body_font ? (themeCss.theme_body_font).replace("+"," ") : '',
            fontSize: 12,
            fontWeight: 100,
            color: theme.palette.primary.contrastText,
            textTransform: 'capitalize',
        },            
    };


  return (
    <Typography component="div" sx={infoContainer}>            
        <Typography component="h6">
            Important Event Info:
        </Typography>
        <Typography component="h5">
            All sales final. No refunds or exchanges. Right of admission
            reserved.{" "}
        </Typography> 
    </Typography>      
  );
}

export default Info;

